import { PageLayout, PageListHeader } from '@/global/components';
import { IconButton, PlusIcon } from '@/lib';
import { BreadcrumbItem } from '@/lib/Breadcrumbs';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { RootState, useAppDispatch } from '../../reducers';
import RouteConstants from '../router/RouteConstants';
import { reset } from './campaignsSlice';
import { CampaignsList } from './components/CampaingnsList';

const breadcrumbs: BreadcrumbItem[] = [
  {
    label: 'campaign:listPageBreadcrumb',
  },
];

export const Campaigns: FC = () => {
  const { t } = useTranslation('campaign');
  const history = useHistory();

  const dispatch = useAppDispatch();

  const uiState = useSelector((state: RootState) => state.campaigns.ui);
  if (!uiState.regular) {
    dispatch(reset());
  }

  return (
    <PageLayout>
      <PageListHeader breadcrumbs={breadcrumbs} title='campaign:title' subtitle='campaign:subtitle'>
        <div className='flex flex-col items-end self-end'>
          <IconButton
            leadingIcon={<PlusIcon className='size-5 text-white-100' />}
            className='inline-flex w-full max-w-[211px] justify-center'
            onClick={() => history.push(RouteConstants.createCampaign)}
            text={t('createCampaign')}
          />
        </div>
      </PageListHeader>
      <CampaignsList />
    </PageLayout>
  );
};
